module.exports = __webpack_public_path__ + "img/ActionBoy.80b0b8aa.png";